import React, { useState } from 'react';
import { field } from '../types';
import { FormControl, InputAdornment, TextField } from '@mui/material';
import { getErrorText } from '..';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import TodayIcon from '@mui/icons-material/Today';
import { CustomTextField } from 'theme/elements/Inputs';
import { filterDates } from 'components/FormElementsComponent/DateRange';
import { defineds } from 'constants/ui.constants';
import { getReportDates, setReportDates } from 'state/reducers/reports.reducers';
import { useTheme } from '@mui/material';
import DateRangePopover from 'components/FormElementsComponent/DateRangePopover';
import _ from 'lodash';
import { formatDate } from 'constants/reports.constants';

type props = {
	valid: boolean;
	cField: field;
	initialValidation: any;
	handleChange?: (dates: { startDate: Date; endDate: Date }) => void;
	sendSelectionToParent?: (dates: { startDate: Date; endDate: Date }) => void;
};

export default function DateRangePickerInput(props: props) {
	const dispatch = useAppDispatch();
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
	const { valid, cField, initialValidation } = props;
	const { name, value, helperText, isInFuture, ...remainingProps } = cField.props;

	const [showCalender, setShowCalender] = useState(false);
	const id = showCalender ? 'simple-calender-popover' : undefined;
	const dateRange = useAppSelector(getReportDates);
	const intialDates: filterDates = {
		startDate: defineds.startOfToday,
		endDate: defineds.endOfToday,
	};

	const [state, setState] = useState([
		{
			startDate: isInFuture ? intialDates.startDate : dateRange.startDate || intialDates.startDate,
			endDate: isInFuture ? intialDates.endDate : dateRange.endDate || intialDates.endDate,
			key: 'selection',
		},
	]);
	const handleClose = () => {
		setAnchorEl(null);
		setShowCalender(false);
	};

	const handleSelect = (ranges: any) => {
		const dates = { startDate: ranges.selection.startDate, endDate: ranges.selection.endDate };
		if (props.handleChange) {
			props.handleChange(dates);
		}
		if (props.sendSelectionToParent) {
			props.sendSelectionToParent(dates);
		} else {
			dispatch(setReportDates(dates));
		}
	};

	const handleClick = (event: any) => {
		setAnchorEl(event.currentTarget);
		setShowCalender(true);
	};

	const handleChangeDatePick = (item: any) => {
		setState([item.selection]);
		handleSelect(item);
	};

	const formatValue = (value: any) => {
		if (['null', 'undefined'].includes(typeof value)) {
			return '';
		}
		if (value?.startDate && value?.endDate) {
			return `${formatDate(value.startDate)} עד ${formatDate(value.endDate)}`;
		}
		return value;
	};

	return (
		<CustomTextField key={name}>
			<FormControl error={!valid} fullWidth sx={cField.styleObj}>
				<TextField
					error={!valid}
					{...remainingProps}
					helperText={valid ? helperText : t(getErrorText(initialValidation, name))}
					value={formatValue(value)}
					onClick={props.cField.props.disabled ? undefined : handleClick}
					variant="filled"
					autoComplete="off"
					InputProps={{
						readOnly: true,
						endAdornment: (
							<InputAdornment position="end">
								<TodayIcon
									sx={{
										color: showCalender
											? theme.palette.root.orange
											: theme.palette.root.basicDeeoGreen,
									}}
								/>
							</InputAdornment>
						),
					}}
				/>
				<DateRangePopover
					id={id}
					showCalender={showCalender}
					anchorEl={anchorEl}
					state={state}
					handleClose={handleClose}
					onChange={handleChangeDatePick}
					isInFuture={isInFuture}
				/>
			</FormControl>
		</CustomTextField>
	);
}
